import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Update,
  GetById,
} from "adminApi/PaymentMethodApi/PaymentMethod";
import feilds from "../json/PaymentMethodFeilds.json";
import { validateForm } from "utils/validation";
import { paymentMethodValidationRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditPaymentMethodForm from "./Componates/EditPaymentMethodForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditPaymentMethod = () => {
  const navigate = useNavigate();      
  const { id } = useParams();
  const { formdata } = feilds;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setValues } = useFormChange(initialValues, paymentMethodValidationRules);

  // Fetch existing data by ID
  const { loading: loadingFetch } = useFetchFormDataById(id, formdata, GetById, setValues);

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Update({id,data:formData});
    },
    (vals) => validateForm(vals, paymentMethodValidationRules),
    () =>{ 
      return navigate(-1)
    },
    "Payment Method updated successfully"
  );
  return (
    <>
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
      <EditPaymentMethodForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Update"
      />
    </>
  );
};

export default EditPaymentMethod;
